export const SET_AVATAR = 'SET_AVATAR';
export const SET_ERROR = 'SET_ERROR';
export const SET_SUCCESS = 'SET_SUCCESS';
export const FETCH_SIGNUP = 'FETCH_SIGNUP';



// WEBPACK FOOTER //
// ./src/routes/SignupTemp/modules/types.js